import { observable } from "mobx"

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type InternshipInterest = {
  major_occupations: {
    id: number
    name: string
  }[]
}

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type InternshipMotivation = {
  frequency?: number | null
  frequency_weekday?: number | null
  available_hours_per_week?: number | null
  period?: number | null
}
interface internshipExperienceArgs {
  interest: InternshipInterest
  internship_motivations: InternshipMotivation
}

export class InternshipExperience {
  @observable interest: InternshipInterest
  @observable internship_motivations: InternshipMotivation

  constructor(args: internshipExperienceArgs) {
    this.interest = args.interest
    this.internship_motivations = args.internship_motivations || {
      frequency: null,
      frequency_weekday: null,
      available_hours_per_week: null,
      period: null,
    }
  }
}
